export const GAMECRAFT_URL = "https://gamecraft.nusgdg.org/";
export const GAMECRAFT_YEAR = 2025;
